import React from 'react';

export const HeaderTable = ({title}) => {
    return (
        <div className="header-table"> <span className="table-title"> {title} </span></div>
    )
}
